export default __webpack_public_path__ + "static/media/united-arab-emirates.a790db14.svg";